// 📦 src/components/ProductCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import AddToCartButton from "./AddToCartButton";

const ProductCard = ({ product, onAdded }) => {
  const isSoldOut = !product.variants?.some((v) => v.availableForSale);

  return (
    <div className="group bg-gradient-to-b from-neutralgray to-neutraldark rounded-lg shadow-md shadow-black/40 overflow-hidden hover:shadow-xl transition-all">
      {/* Product image links to detail page */}
      <Link to={`/product/${product.handle}`}>
        <div className="relative">
          <img
            src={product.image}
            alt={product.imageAlt}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform"
          />
          {isSoldOut && (
            <span className="absolute top-2 left-2 bg-brandred text-white text-xs px-2 py-1 rounded">
              Sold Out
            </span>
          )}
        </div>
      </Link>

      {/* Info */}
      <div className="p-4 flex flex-col gap-2">
        <Link to={`/product/${product.handle}`}>
          <h2 className="text-lg font-bold text-gray-100 line-clamp-2">
            {product.title}
          </h2>
        </Link>
        <p className="text-brandred text-sm font-semibold">${product.price.toFixed(2)}</p>

        <AddToCartButton
          variantId={product.variantId}
          available={!isSoldOut}
          onAdded={onAdded}
          checkoutLabel="Go to Checkout →"
          successBehavior="replace"
          showContinueShoppingLink={true}
          layoutClassName="w-full"
          buttonClassName="w-full py-3 text-base"
          checkoutClassName="w-full py-3 text-base"
        />
      </div>
    </div>
  );
};

export default ProductCard;
